"use client"

import type { ReactNode } from "react"

import { ContactLink } from "@/components/layout/ContactLink"
import type { ContactServiceId } from "@/data/contact"
import { trackEvent } from "@/lib/analytics"

/** フォームへの遷移は相談導線のクリックとして記録し、送信完了とは区別する。 */
export function BrickInquiryLink({
  href = "/business/yoshinani-brick#contact",
  location,
  service = "yoshinani-brick",
  className,
  external = false,
  onNavigate,
  workId,
  children,
}: {
  href?: string
  location: string
  service?: ContactServiceId
  className?: string
  external?: boolean
  workId?: string
  onNavigate?: () => void
  children: ReactNode
}) {
  return (
    <ContactLink
      href={href}
      data-cta-tracked="true"
      data-cta-location={location}
      className={className}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      onNavigate={onNavigate}
      onClick={() =>
        trackEvent("cta_click", {
          cta_location: location,
          service_id: service,
          work_id: workId,
          ...(href.startsWith("/contact")
            ? {
                form_type:
                  new URL(href, "https://yoshinani.co.jp").searchParams.get(
                    "purpose",
                  ) === "materials"
                    ? "materials"
                    : "consultation",
              }
            : {}),
          destination:
            href.startsWith("/contact") || external
              ? "contact_form"
              : "service_page",
        })
      }
    >
      {children}
    </ContactLink>
  )
}
